import {CommonMessages} from '../common.messages';

export const AddUserToClientMessages = {
    RegisterClientUserFailed: {
        key: 'RegisterClientUserFailed',
        message: 'Error while processing the server request. Creation process failed.'
    },
    ...CommonMessages
};
